"use client";

import React, { createContext, ReactNode, useContext, useState } from "react";
import { useClipboard } from "@/hooks/use-clipboard";

type CopyContextState = {
  isTextCopied: (text: string) => boolean;
  copyText: (text: string) => Promise<void>;
};

const CopyContext = createContext<CopyContextState | undefined>(undefined);

export const useCopyContext = (): CopyContextState => {
  if (!CopyContext) {
    throw new Error("CopyContext is undefined");
  }

  return useContext(CopyContext)!;
};

const CopyProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [copiedText, setCopiedText] = useState<string>();
  const { copyToClipboard } = useClipboard();

  const isTextCopied = (text: string) => text === copiedText;

  const copyText = async (text: string) => {
    await copyToClipboard(text);
    setCopiedText(text);
  };

  return (
    <CopyContext.Provider value={{ isTextCopied, copyText }}>
      {children}
    </CopyContext.Provider>
  );
};

export default CopyProvider;
